export const validateEmail = (email: string) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const validatePhone = (phone: string) => {
  const countryCodeRegx = /^(\+84|84)+/
  const phoneValidRegx = /^[0-9]+$/
  const phoneRegx =
    /^(03[2-9]|08[1-9]|09[0-4,6-9]|05[2,5-9]|07[0,6-9])[0-9]{7}$/

  const errorCodes = {
    INVALID_LENGTH: {
      valid: false,
      message: 'SĐT phải là 10 số',
    },
    INVALID_CHARACTERS: {
      valid: false,
      message: 'SĐT không hợp lệ',
    },
    VALID_PHONE: {
      valid: true,
      message: 'SĐT hợp lệ',
    },
  }

  phone = phone.toString()
  phone = phone.replace(countryCodeRegx, '0')

  if (!phoneValidRegx.test(phone)) {
    return errorCodes.INVALID_CHARACTERS
  }
  if (phone.length < 10 || phone.length > 10) {
    return errorCodes.INVALID_LENGTH
  }
  if (!phoneRegx.test(phone)) {
    return errorCodes.INVALID_CHARACTERS
  }
  return errorCodes.VALID_PHONE
}
